// extracted by mini-css-extract-plugin
export default {"root":"shortlist_item_notes-module___root___fb696e9f"};